import React, { FC } from 'react';
import { css } from 'linaria';

import Text from '../Text';

const styles = {
  container: css`
    padding: 5%;
    min-height: 9.5rem;
    @screen lg {
      min-height: 12rem;
      @apply px-0 py-8;
    }
  `,
  textContainer: css`
    max-width: 36rem;
  `,
};

interface Props {
  title: string;
  subTitle?: string;
}

const TitlePromoBanner: FC<Props> = ({ subTitle, title }) => {
  return (
    <div className={`flex items-center justify-center ${styles.container}`}>
      <div className={`space-y-2 lg:space-y-4 text-lapel text-center ${styles.textContainer}`}>
        <h1 className="heading-large lg:heading-xlarge">{title}</h1>
        {subTitle ? (
          <Text as="p" className="paragraph-small lg:paragraph-large">
            {subTitle}
          </Text>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(TitlePromoBanner);
